import classnames from 'classnames';
import React from 'react';

import styles from '@/components/global/buttons/button-small.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  secondary?: boolean;
  phantom?: boolean;
  classNames?: string;
}

const ButtonSmall = (props: Props): React.JSX.Element => {
  const { disabled, primary, secondary, phantom, classNames, ...rest } = props;
  const className = classnames({
    [styles.button]: true,
    [styles.disabled]: disabled,
    [styles.primary]: primary,
    [styles.secondary]: secondary,
    [styles.phantom]: phantom
  });
  return (
    <button aria-disabled={disabled === true ? 'true' : undefined} className={`${className} ${classNames || ''}`} disabled={disabled} {...rest}>
      {props.children}
    </button>
  );
};

export default ButtonSmall;
